import { GetCashiersAttributes } from '@/api'

export interface State {
  cashiers: GetCashiersAttributes[]
}
export const initState = (): State => ({
  cashiers: [],
})
